import { calculatePiecesFromWeight } from "../shared/amount-chooser-panel/index";
import type { Weight } from "./BaseTypes";
export function getQuantityForPopup(quantity: number, weightPerPiece: Weight | null | undefined): number {
	return weightPerPiece && weightPerPiece.value
		? calculatePiecesFromWeight(quantity, weightPerPiece.value)
		: quantity;
}
